import { GlSorting } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import FilteredSearchBar from '../../vue_shared/components/filtered_search_bar/filtered_search_bar_root.vue?vue3';
import { RECENT_SEARCHES_STORAGE_KEY_GROUPS, RECENT_SEARCHES_STORAGE_KEY_PROJECTS } from '~/filtered_search/recent_searches_storage_keys';
import { filterToQueryObject, processFilters, urlQueryToFilter, prepareTokens } from '~/vue_shared/components/filtered_search_bar/filtered_search_utils';
import { FILTERED_SEARCH_TERM, TOKEN_EMPTY_SEARCH_TERM } from '~/vue_shared/components/filtered_search_bar/constants';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'FilteredSearchAndSort',
    components: {
        FilteredSearchBar,
        GlSorting
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        filteredSearchTokens: {
            type: Array,
            required: true
        },
        /**
     * Filtered search value as an object. Can come from `$route.query` if using Vue router
     * or manually convert the query string to an object using `queryToObject` util.
     *
     * Example:
     *
     * {
     *   search: 'foo bar',
     *   role: 'Owner'
     * }
     */ filteredSearchQuery: {
            type: Object,
            required: true
        },
        filteredSearchTermKey: {
            type: String,
            required: true
        },
        filteredSearchNamespace: {
            type: String,
            required: true
        },
        filteredSearchRecentSearchesStorageKey: {
            type: String,
            required: true,
            validator (value) {
                return [
                    RECENT_SEARCHES_STORAGE_KEY_GROUPS,
                    RECENT_SEARCHES_STORAGE_KEY_PROJECTS
                ].includes(value);
            }
        },
        sortOptions: {
            type: Array,
            required: false,
            default () {
                return [];
            }
        },
        activeSortOption: {
            type: Object,
            required: true
        },
        isAscending: {
            type: Boolean,
            required: true
        },
        searchInputPlaceholder: {
            type: String,
            required: false,
            default: __('Filter or search (3 character minimum)')
        }
    },
    emits: [
        'filter',
        'sort-by-change',
        'sort-direction-change'
    ],
    computed: {
        filteredSearchValue () {
            const tokens = prepareTokens(urlQueryToFilter(this.filteredSearchQuery, {
                filteredSearchTermKey: this.filteredSearchTermKey,
                filterNamesAllowList: [
                    FILTERED_SEARCH_TERM,
                    ...this.filteredSearchTokens.map(({ type })=>type)
                ]
            }));
            return tokens.length ? tokens : [
                TOKEN_EMPTY_SEARCH_TERM
            ];
        },
        shouldShowSort () {
            return this.sortOptions.length;
        }
    },
    methods: {
        onFilter (filters) {
            this.$emit('filter', filterToQueryObject(processFilters(filters), {
                filteredSearchTermKey: this.filteredSearchTermKey,
                shouldExcludeEmpty: true
            }));
        }
    }
};
